import { useMutation } from 'react-query';
import WgApiError, {
  ApiErrorObject,
} from '../../../app/src/features/api/classes/WgApiError';
import { wgApi } from '../../../app/src/features/api/wgApi';
import { NewCreateFlowPayload } from '../types/ApiTypes';
import { FlowsResponse } from '../types/FlowsTypes';

interface Params {
  flowId: string;
  payload: NewCreateFlowPayload;
}

export const createFlowById = async ({ flowId, payload }: Params) => {
  const { data, isError } = await wgApi.post<FlowsResponse | ApiErrorObject>(
    `v1/api/flows/${flowId}/conversations`,
    payload,
  );
  if (isError) throw new WgApiError(data as ApiErrorObject);
  return data as FlowsResponse;
};

export const useCreateFlowById = () => {
  return useMutation(createFlowById);
};
